/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import { action } from "mobx";
import { IRegistrationDetails, ISiteDetails } from "./IGatewayRegistrationInterfaces";
import axiosInstance from "./ForgeAxiosInstance";
import GlobalStore from "../GlobalStore/GlobalStore";
import { IGatewayDetail } from "../../components/gateway/registration/IGatewayDetails";
import ForgeAxiosInstance from "./ForgeAxiosInstance";
/**
 * This store takes care of registerting the gateway with the tenant account.
 */
export default class GatewayRegistrationStore extends GlobalStore {

  /**
   * Associate the gateway to the site.
   */
  @action
  registerGatewayByDeviceId(deviceDetails: IRegistrationDetails, siteDetails: ISiteDetails) {
    let envVars = this.envVariables;
    let registerGatewayURL =
      `${envVars.GATEWAY_MANAGEMENT_BASE_API_URL}${this.GATEWAY_DEVICE_ASSOCIATION_API_URL_BASE}`;
    registerGatewayURL = `${registerGatewayURL}/${deviceDetails.deviceId}`;
    return axiosInstance.getInstance()({
      url: registerGatewayURL,
      method: 'PUT',
      headers: {
        'organizationid': siteDetails.siteId
      },
      data: {
        custom_attributes: {
          site_id: (!!siteDetails.siteId) ? siteDetails.siteId : ""
        },
        serial_number: deviceDetails.serialNumber,
        name: `${siteDetails.siteName}-${deviceDetails.deviceId}`
      }
    });
  }

  /**
   * Register the gateway using enrollment id
   * @param {IRegistrationDetails} deviceDetails
   * @param {ISiteDetails} siteDetails
   */
  @action
  registerGatewayByEnrollmentId(deviceDetails: IRegistrationDetails, siteDetails: ISiteDetails) {
    let envVars = this.envVariables;
    let registerGatewayURL =
      `${envVars.GATEWAY_MANAGEMENT_BASE_API_URL}${this.GATEWAY_DEVICE_ENROLLMENT_API_URL_BASE}`;
    return axiosInstance.getInstance()({
      url: registerGatewayURL,
      method: 'POST',
      headers: {
        'customerid': siteDetails.customerDetails.organizationId,
        'organizationid': siteDetails.siteId
      },
      data: {
        'enrollment_identity': deviceDetails.enrollmentId,
        'gateway_name': siteDetails.gatewayName,
        'site_name': siteDetails.siteName,
        'serial_number': deviceDetails.serialNumber,
        'original_ep': deviceDetails.epName,
        'customer_name': siteDetails.customerDetails.organizationName || ''
      }
    });
  }

  @action
  getCustomerDetails = async (siteId: string) => {
    return this.getCustomerDetailsPromise(siteId).then((response: any) => {
      return response;
    });

  };


  private getCustomerDetailsPromise = (siteId: string): any => {
    let envVariables = this.envVariables;
    let siteListURL = `${envVariables.GATEWAY_MANAGEMENT_BASE_API_URL}${this.GATEWAY_CUSTOMER_DETAILS_URL_BASE}` + siteId;
    return axiosInstance.getInstance()({
      url: siteListURL,
      method: 'GET',
      headers: {
        'organizationId': siteId
      }
    }).catch(() => {
      //do not perform any action if this call fails
    });
  }

  @action
  getGateways(projectId:string){

    let envVars = this.envVariables;
    let registerGatewayURL =
      `${envVars.FCP_API_BASE_URL}${this.FORGECONNECT_BASE_URL_ENDPOINT}${projectId}` + '/gateway?claimed=false&profile=appliance';

      return ForgeAxiosInstance.getForgeEPMInstance()
      .get<IGatewayDetail>(
        registerGatewayURL
      );
    }
    
  private readonly GATEWAY_DEVICE_ASSOCIATION_API_URL_BASE = '/api/gateways';

  private readonly GATEWAY_DEVICE_ENROLLMENT_API_URL_BASE = '/api/gateways/enrollments';

  private readonly GATEWAY_CUSTOMER_DETAILS_URL_BASE = '/api/v1/site/';

  private readonly FORGECONNECT_BASE_URL_ENDPOINT = '/v1/projects/';

}
